import { Transform, TransformFnParams } from 'class-transformer';
import { isPhoneNumberValid } from '@red/pipes/phone-number';

export function ValidPhoneNumber(defaultValue: unknown = null) {
  return Transform((params: TransformFnParams) => {
    if (isPhoneNumberValid(params.value)) return params.value;
    return defaultValue;
  });
}
